import { useQuery } from "@tanstack/react-query";
import { fetchData } from "./UseStudentGetApi";
import { fetchData as fetchDataNode } from "../nodeApi/fetchData";

export const useTranerUnderCoorList = (id) => {
  return useQuery({
    queryKey: ["coordinator-apartment-count", id],
    queryFn: () => fetchDataNode(`coordinator-apartment-count/${id}`),
  });
};

export const useStudentListUnderCoordiList = () => {
  return useQuery({
    queryKey: ["get-all-register-students-by-Coordinator"],
    queryFn: () => fetchDataNode(`get-all-register-students-by-Coordinator`),
  });
};

export const useLeadStudentList = () => {
  return useQuery({
    queryKey: ["student-leads"],
    queryFn: () => fetchDataNode(`student-leads`),
  });
};

export const useApartmentUnderCoordinator = (filters) => {
  return useQuery({
    queryKey: ["coordinator/apartments",filters],
    queryFn: () => fetchDataNode(`coordinator/apartments`,filters),
  });
};

export const useCoordinatorStudentEnList= (filters) => {
  return useQuery({
    queryKey: ["cluster/student-leads",filters],
    queryFn: () => fetchDataNode(`cluster/student-leads`,filters),
  });
};

export const useZoneHeadManagerStudentEnList= (filters) => {
  return useQuery({
    queryKey: ["zone-head/student-leads",filters],
    queryFn: () => fetchDataNode(`zone-head/student-leads`,filters),
  });
};